import { CSSProperties, memo } from 'react';
import { Box, CircularProgress, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface StyleProps {
  color?: CSSProperties['color'];
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: ({ color }: StyleProps) => color || theme.palette.primary.main
  }
}));

interface Props {
  size?: number;
  color?: CSSProperties['color'];
}

const Loader = ({ size = 40, color }: Props) => {
  const classes = useStyles({ color });

  return (
    <Box className={classes.root}>
      <CircularProgress size={size} color="inherit" />
    </Box>
  );
};

export default memo(Loader);
